import type { AdminAbility } from '@repo/sdk/backoffice-abilities'
import type { QueryClient } from '@tanstack/react-query'
import { adminSessionQueryOptions } from '@/lib/query-options'
import {
	hasAdminAbility,
	type PermissionCheckOptions
} from '@/modules/permissions/lib/has-admin-ability'
import { PermissionError } from '@/modules/permissions/lib/permission-error'

export function requireAdminPermission(
	abilities: AdminAbility[],
	options?: PermissionCheckOptions
) {
	return async (routeContext: { context: { queryClient: QueryClient } }) => {
		// The parent (private) guard has already fetched the session; this only reads the cache.
		const data = await routeContext.context.queryClient.ensureQueryData(
			adminSessionQueryOptions()
		)
		const granted =
			data.sessionType === 'authenticated' ? data.abilities : null

		if (!hasAdminAbility(granted, abilities, options)) {
			throw new PermissionError()
		}
	}
}
